import React from 'react';
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserProfile } from '../hooks/useUserProfile';
import { paths } from '../../../../app/routes/paths';
import { useRolePath } from '../../../../app/routes/useRolePath';
import avatarMan from '../../../../assets/images/avatars/avatar-man.svg';
import './DashboardProfile.scss';

export const DashboardProfile: React.FC = () => {
  const { t } = useTranslation();
  const toRolePage = useRolePath();
  const { view, isLoading } = useUserProfile();
  const profilePath = toRolePage(paths.settingsProfile);

  return (
    <Flex className='dashboard-profile'>
      <Box className='dashboard-profile__avatar'>
        <Image src={view.avatarUrl || avatarMan} alt='' />
      </Box>
      <Flex className='dashboard-profile__info'>
        {view.id && (
          <Text className='dashboard-profile__id'>
            {t('dashboard.profile-id', { id: view.id })}
          </Text>
        )}
        <Text className='dashboard-profile__name'>
          {view.displayName || (isLoading ? '…' : '')}
        </Text>
        {view.email && (
          <Text className='dashboard-profile__email'>{view.email}</Text>
        )}
        {view.phone && (
          <Text className='dashboard-profile__phone'>{view.phone}</Text>
        )}
      </Flex>
      <Button
        as={Link}
        to={profilePath}
        className='dashboard-profile__edit'
        variant='outline'
        size='sm'
      >
        {t('common.edit')}
      </Button>
    </Flex>
  );
};

export default DashboardProfile;
